import React from "react";
import LazyLoad from "react-lazyload";
import classnames from "classnames";

import { IRecItem } from "../../api";

import styles from "./Recommend.module.css";
import { BUSINESS_INFO } from "../../constant";

function Recommend(props: IRecItem) {
  const {
    assetsDisposal,
    categoryId,
    categoryName,
    creditCapitalAndTerestCN,
    id,
    intendedPersonNum,
    mainImgUrl,
    name,
    merchantsStatus,
    onlookersNum,
    referenceUpperLimitCN,
    referenceLowerLimitCN,
    creditTotalChargesCN,
    publishSource,
    provinceName,
    cityName,
  } = props;
  const isZhaiquan = categoryId === 12767;
  return (
    <div
      className={classnames(styles.rec, {
        [styles.rec1]: merchantsStatus === 1,
        [styles.rec2]: merchantsStatus === 2,
        [styles.rec3]: merchantsStatus === 3,
      })}
    >
      <a
        href={parseInt(publishSource)===BUSINESS_INFO.ZICHAN.code?`//auction.jd.com/zichan/tuijie/item/${id}`:`//auction.jd.com/bankrupt/tuijie/item/${id}`}
        target="_blank"
        rel="noopener noreferrer"
        className={classnames(styles.link)}
      >
        {" "}
      </a>
      <div className={styles.pic}>
        <LazyLoad height={192}>
          <img
            src={`//img1${id %
              5}.360buyimg.com/paimai/s288x1000_${mainImgUrl}!cc_3x2`}
            alt={name}
          />
        </LazyLoad>
      </div>
      <div className={classnames(styles.padding, styles.name)}>{name}</div>
      {isZhaiquan ? (
        <div className={classnames(styles.padding, styles.price)}>
          <span className={styles.label}>债权总额：</span>
          {!creditTotalChargesCN ? 
            (<span className={styles.noPrice}>欢迎询价</span>) : 
            (<span>
              {creditTotalChargesCN && <i className={styles.symbol}>&#65509;</i>}
              <em className={classnames(styles.value, {
                  [styles.small]: creditTotalChargesCN.length > 11
                })}>
                <b className={styles.number}>{creditTotalChargesCN}</b>
              </em>
            </span>)
        }
        </div>
      ) : (
        <div className={classnames(styles.padding, styles.price)}>
          <span className={styles.label}>参考价值：</span>
          {(referenceLowerLimitCN !== "" || referenceUpperLimitCN !== "") && (
            <i className={styles.symbol}>&#65509;</i>
          )}
          <em
            className={classnames(styles.value, {
              [styles.small]:
                (((referenceLowerLimitCN===referenceUpperLimitCN) && referenceLowerLimitCN.length > 11) || ((referenceLowerLimitCN!==referenceUpperLimitCN) && (referenceLowerLimitCN.length+referenceUpperLimitCN.length) > 9)),
              [styles.smaller]:
                ((referenceLowerLimitCN!==referenceUpperLimitCN) && (referenceLowerLimitCN.length+referenceUpperLimitCN.length) > 14),
            })}
          >
            {referenceLowerLimitCN === "" &&
              referenceUpperLimitCN === "" &&
              <div className={styles.zanwunumber}>欢迎询价</div> 
            }
            <b className={styles.number}>
              {(() => {
                if (referenceLowerLimitCN !== "" && referenceUpperLimitCN==="") {
                  return referenceLowerLimitCN+"以上";
                } else if (referenceUpperLimitCN !== "" && referenceLowerLimitCN==="") {
                  return referenceUpperLimitCN+"以下";
                }else if(referenceLowerLimitCN !== "" && referenceUpperLimitCN!==""){
                  if(referenceLowerLimitCN!==referenceUpperLimitCN){
                    return referenceLowerLimitCN+"-"+referenceUpperLimitCN;
                  }else{
                    return referenceLowerLimitCN;
                  }
                }
              })()}
            </b>
          </em>
        </div>
      )}
      <div className={classnames(styles.category, styles.padding)}>
        <span className={styles.label}>资产类型：</span>
        <em className={styles.value}>{categoryName}</em>
      </div>
      {parseInt(publishSource)!==BUSINESS_INFO.POCHAN.code &&
        <div className={classnames(styles.disposal, styles.padding)}>
          <span className={styles.label}>处置主体：</span>
          <em className={styles.value} title={assetsDisposal}>
            {assetsDisposal}
          </em>
        </div>
      }
      {parseInt(publishSource)===BUSINESS_INFO.POCHAN.code && provinceName && 
        <div className={classnames(styles.category, styles.padding)}>
          <span className={styles.label}>资产所在地：</span>
          <em className={styles.value}>{provinceName} {cityName}</em>
        </div>
      }
      <div className={styles.status}>
        <div className={styles.label}>
          {merchantsStatus === 1 && "招商中"}
          {merchantsStatus === 2 && "已转竞价"}
          {merchantsStatus === 3 && "招商结束"}
          {merchantsStatus === 4 && "关闭"}
        </div>
        {intendedPersonNum ? `${intendedPersonNum}名意向人` : null}
        {intendedPersonNum && onlookersNum ? " | " : null}
        {onlookersNum ? `${onlookersNum}次围观` : null}
      </div>
    </div>
  );
}

export default Recommend;
